import downloadBlob from './downloadBlob';

/**
 * @param {string} fileName
 * @param {string} textContent
 * @param {Object} [options]
 * @param {string} [options.type]
 */
export default function downloadTextFile(fileName, textContent, options = {}) {
    const {
        type = 'text/plain'
    } = options;

    downloadBlob(fileName, new Blob([textContent], { type }));
}